import type { FaireProductEntity } from "../../entity_types/product";

export const p_k9njh275f3: FaireProductEntity = {
  token: "p_k9njh275f3",
  type: "product",
  name: "Katjes Wunderland Sauer Edition 175g (Germany)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/00c24905526c72c2596ed336a76138a17dd14a41f243c3616289b09f4506716b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1119de4c3e48963de5ddcce4d668adacdb13eff4375822c739cf32c55c9ecb61.jpeg",
  ],
  priceDollars: 3.67,
  description:
    "Katjes Wunderland Sauer 175 g (Germany) is an imported, vegan fruit gummy featuring a vibrant mix of five sour flavors—blackcurrant, peach, raspberry, lime, and blood orange. These naturally colored and flavored gummies blend bold tartness with fruity sweetness, offering global flavors and a taste that’s truly unique. Perfect for adventurous snackers seeking a zingy, playful twist.\n",
  tags: [],
  msrpDollars: 6.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:47.158Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
